export type TemplateCategory =
  | 'Personal portfolio'
  | 'Small business'
  | 'Shopping'
  | 'Service provider'
  | 'Restaurant & events'
  | 'Media library'

/** Display order of the category filter pills. Stable, app-level constant. */
export const TEMPLATE_CATEGORIES: TemplateCategory[] = [
  'Small business',
  'Personal portfolio',
  'Service provider',
  'Restaurant & events',
  'Media library',
  'Shopping',
]

/** Minimal shape a gallery card needs (live-URL preview + labels). */
export interface TemplateCardData {
  slug: string
  name: string
  category: TemplateCategory
  oneLiner: string
  liveDemoUrl: string
  previewAlt?: string
}

export interface TemplateSpec {
  slug: string
  name: string
  category: TemplateCategory
  /** Card + detail subtitle, ≤90 chars. */
  oneLiner: string
  /** Detail intro + meta description, ≤160 chars. */
  description: string
  /** /templates/<slug>.webp — 1200×750 card image. */
  previewImage: string
  /** /templates/<slug>@2x.webp — 2400×1500, detail srcset. */
  previewImage2x: string
  /** /templates/<slug>-og.png — 1200×630 share card (PNG: scrapers mishandle WebP). */
  ogImage: string
  /** Describes the site itself, not "screenshot of". */
  previewAlt: string
  /** Launch: set on coffee-website only. Unset = demo link not rendered (kill-switch). */
  liveDemoUrl?: string
  /**
   * Single universal prompt, ≤1,500 chars (deep-link budget).
   * Canonical shape: starts with the /start install preamble, constrains the
   * agent to a new directory, and ends with the ask-first /opendeploy line.
   */
  prompt: string
  /** "What your agent builds". If needsDatabase, the FINAL item is the DB callout. */
  builds: string[]
  stack: string[]
  needsDatabase: boolean
  /** Each rendered as its own copy chip. */
  followUpPrompts: string[]
  /** Added date — drives sitemap lastmod. */
  date: string
  updated?: string
}
